export enum LABELS {
  twampServerIP = 'twamp control server ip',
  twampServerPort = 'twamp control server port',
  twampMaxFrameSize = 'twamp max frame size',
  twampMaxFlows = 'twamp max flows',
  twampIpv6 = 'twamp ipv6',
  twampMaxControlSessions = 'twamp max control sessions',
  twampLightIP = 'twamp light reflector ip',
  twampLightPort = 'twamp light reflector port',
  twampLightIpv6 = 'twamp light ipv6',
  twampLightMaxFlows = 'twamp light max flows',
  twampLightMaxFrameSize = 'twamp light max frame size',
  twampPingIP = 'twamp ping reflector ip',
  longitude = 'longitude',
  latitude = 'latitude',
  location = 'location',
  l2Loopback = 'l2 loopback',
  l3Ipv4Loopback = 'l3 ipv4 loopback',
  l3Ipv6Loopback = 'l3 ipv6 loopback'
}

